import api, { formatApiError } from "./api";
import { getBrandOrigin } from "./brand";
import { toast } from "sonner";

const download = (blob, name) => { const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 60000); };

/* Public result poster PNG (server-rendered, cached, no customer names) → Web Share file; if the phone refuses the share sheet (gesture expired / unsupported) → save + open WhatsApp. */
export async function shareResultImage(r, ta = false) {
  const text = ta
    ? `👑 ROYAL LAKSHMI · ${r.game_name} result: ${r.winning_number}\nஇன்றைய winners-ஐ card-ல பாருங்க. நீங்களும் விளையாடுங்க 👉 ${getBrandOrigin()}`
    : `👑 ROYAL LAKSHMI · ${r.game_name} result: ${r.winning_number}\nSee today's winners on the card. Play & win 👉 ${getBrandOrigin()}`;
  let data;
  try {
    ({ data } = await api.get(`/results/${r.id}/card.png`, { params: { lang: ta ? "ta" : "en" }, responseType: "blob", timeout: 30000 }));
  } catch (e) {
    let detail = "";
    try { detail = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : e.response?.data?.detail; } catch {}
    toast.error((ta ? "Result image build ஆகல" : "Could not build the result image") + (detail ? ` — ${formatApiError(detail)}` : e.message ? ` — ${e.message}` : ""), { duration: 8000 });
    return "error";
  }
  const file = new File([data], `royal-lakshmi-result-${r.winning_number}.png`, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], text }); return "shared"; }
    catch (e) { if (e?.name === "AbortError") return "cancelled"; /* NotAllowedError etc. → fall back below */ }
  }
  download(data, file.name);
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  toast.success(ta ? "Result image save ஆனது — WhatsApp-ல attach பண்ணுங்க" : "Result image saved — attach it on WhatsApp");
  return "downloaded";
}
